import { type ClassValue, clsx } from "clsx";
import { useState } from "react";
import { useEffectOnce } from "react-use";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/**
 * Initially sets tabIndex to -1 and then to 0 so that focus managers like `FocusScope` do not
 * autofocus an element.
 */
export const useNotAutofocusableTabIndex = () => {
	const [tabIndex, setTabIndex] = useState(-1);
	useEffectOnce(() => setTabIndex(0));
	return tabIndex;
};
